export const ExpansePDFHeader = [
    "Name",
    "Amount",
    "Category",
    "Expense Date",
    "Created  Date",
    "Modified Date",
  ];